import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_BG.json';
import exercises from './PILATES_EXERCISES_BG.json';
import recipes from './PILATES_RECIPES_BG.json';

export const PILATES_DATA_BG: ServiceData = {
  articles,
  exercises,
  recipes,
};
